export const GAMES_SEARCH_SYMBOLS_THRESOLD = 2;
